// src/modules/Profile/hooks/useUpdateProfile.ts
import { useMutation } from '@tanstack/react-query';
import { apiClientWH } from '@shared/services';
import { createHttpClient } from '@adapters/HttpClient';
import { ProfileApiAdapter } from '../adapters/ProfileApiAdapter';
import { ProfileUpdateService } from '../services/ProfileUpdateService';

const httpClient = createHttpClient(apiClientWH);
const adapter = new ProfileApiAdapter(httpClient);
const service = new ProfileUpdateService(adapter);

export const useUpdateProfile = () => {
  const updateUserMutation = useMutation({
    mutationFn: (payload: any) => service.updateUser(payload),
  });

  const updateEmailMutation = useMutation({
    mutationFn: (payload: any) => service.updateEmail(payload),
  });

  return {
    updateUser: updateUserMutation.mutateAsync,
    isLoading: updateUserMutation.isPending, // tanstack v5
    updateEmail: updateEmailMutation.mutateAsync,
    isEmailLoading: updateEmailMutation.isPending,
  };
};
